/**
 * Transformuje sorting z formátu { type } na formát { direction } pro backend
 */
export const transformSortingTypeToDirection = (
  sorting?: Array<{ field: string; type: string }>
): Array<{ field: string; direction: string }> | undefined => {
  return sorting?.map((sort) => ({
    field: sort.field,
    direction: sort.type,
  }));
};

/**
 * Transformuje condition objekt, který obsahuje sorting s { type } na formát s { direction }
 */
export const transformConditionSorting = <T extends { sorting?: Array<{ field: string; type: string }> }>(
  condition: T | undefined
): T | undefined => {
  if (!condition) return undefined;

  return {
    ...condition,
    sorting: transformSortingTypeToDirection(condition.sorting),
  };
};
